<template>
    <div class="shop-item-quantity">
        <span> {{ $t('orderquantity') }}</span>
        <global-button theme="secondary" icon="minus" @click="minusItemCount()" :disabled="minusButtonDisabled" />
        <input :class="ordercountTextColor" type="text" @input="checkOrderMaxItems($event.target)" min="1" :value="quantity"
               size="3">
        <global-button theme="secondary" icon="plus" @click="plusItemCount()" />
        <div class="shop-item-quantity-error" v-show="errorItemQuantity !== ''" v-html="errorItemQuantity"></div>
    </div>
</template>
<script>
import GlobalButton from "@global/global-elements/global-button/global-button";

export default {
    name: "shop-item-quantity",
    components: {GlobalButton},
    props: {
        tile: Object,
        itemSectionTitle: String,
        maxOrderItems: Number
    },
    data() {
        return {
            quantity: 1,
            minusButtonDisabled: true,
            plusButtonDisabled: false,
            ordercountTextColor: 'ordercount-text-color-default',
            errorItemQuantity: ''
        }
    },
    computed: {
        localization() {
            return window.cartLocalization
        }
    },
    methods: {
        minusItemCount() {
            if (this.quantity > 1) {
                this.quantity = parseInt(this.quantity) - 1;
            }
            if (this.quantity == 1) this.minusButtonDisabled = true;
            if (this.quantity <= this.maxOrderItems) {
                this.errorItemQuantity = "";
                this.ordercountTextColor = 'ordercount-text-color-default';
                this.$emit('updateErrorItemQuantity', false);
            }
        },
        plusItemCount() {
            this.quantity = parseInt(this.quantity) + 1;
            let errorItemQuantity = this.$t('errorItemQuantity');
            let errorItemQuantityMessage = errorItemQuantity.replace('#s#', this.maxOrderItems + " " + this.itemSectionTitle);
            if (this.quantity > this.maxOrderItems) {
                this.errorItemQuantity = errorItemQuantityMessage;
                this.ordercountTextColor = 'ordercount-text-color-attention';
                this.$emit('updateErrorItemQuantity', true);
            }
            // wenn > 1 evtl. deaktierten - Button aktivieren
            if (this.quantity > 1) this.minusButtonDisabled = false;
        },
        checkOrderMaxItems(element) {
            let orderValue = parseInt(element.value);
            let errorItemQuantity = this.$t('errorItemQuantity');
            let errorItemQuantityMessage = errorItemQuantity.replace('#s#', this.maxOrderItems + " " + this.itemSectionTitle);
            if(orderValue >= 1) {
                this.quantity = orderValue;
                if ((this.maxOrderItems - orderValue) < 0) {
                    this.errorItemQuantity = errorItemQuantityMessage;
                    this.ordercountTextColor = 'ordercount-text-color-attention';
                    this.$emit('updateErrorItemQuantity', true);
                }else{
                    this.errorItemQuantity = '';
                    this.ordercountTextColor = 'ordercount-text-color-default';
                    this.$emit('updateErrorItemQuantity', false);
                    this.$emit('updateCartData', this.quantity);
                }
            }else{
                this.quantity = "";
                this.errorItemQuantity = this.$t('errorItemQuantityEmpty');
                this.$emit('updateErrorItemQuantity', true);
            }
        }
    }
}
</script>
